import './App.css';
import {BrowserRouter as Router, Redirect, Route, Switch} from 'react-router-dom';
import SignIn from './pages/signin';
import theme from './config/theme'
import {ThemeProvider} from '@material-ui/styles';
import {create} from 'jss';
import rtl from 'jss-rtl';
import {jssPreset, StylesProvider} from '@material-ui/core/styles';
import React from "react";
import Users from "./pages/users";
import ContextProvider from "./contexts";
import Dashboard from "./pages/dashboard";
import Devices from "./pages/devices/devices";
import User from "./pages/user";
import Roles from "./pages/roles";
import Logs from "./pages/logs";
import CreateUser from "./pages/create-user";
import Models from './pages/devices/models';
import InsertDevice from './pages/devices/insert-device';
import InsertedDevices from './pages/devices/inserted-devices';
import Uploads from './pages/uploads';

const jss = create({plugins: [...jssPreset().plugins, rtl()]});

function App() {
    return (
        <ContextProvider>
            <StylesProvider jss={jss}>
                <ThemeProvider theme={theme}>
                    <Router>
                        <Switch>
                            <Route path="/dashboard" exact>
                                <Dashboard/>
                            </Route>
                            <Route path="/devices" exact>
                                <Devices/>
                            </Route>
                            <Route path="/devices/models" exact>
                                <Models/>
                            </Route>
                            <Route path="/signin" exact>
                                <SignIn/>
                            </Route>
                            <Route path="/users" exact>
                                <Users/>
                            </Route>
                            <Route path="/users/create-user" exact>
                                <CreateUser/>
                            </Route>
                            <Route path="/roles" exact>
                                <Roles/>
                            </Route>
                            <Route path="/logs" exact>
                                <Logs/>
                            </Route>
                            <Route path="/uploads" exact>
                                <Uploads/>
                            </Route>

                            <Route path="/devices/insert" exact>
                                <InsertDevice/>
                            </Route>

                            <Route path="/devices/inserted-devices" exact>
                                <InsertedDevices/>
                            </Route>

                            <Route path="/">
                                <Redirect to='/dashboard'/>
                            </Route>

                        </Switch>
                    </Router>
                </ThemeProvider>
            </StylesProvider>
        </ContextProvider>
    );
}

export default App;
